import { Colors } from '@sigma-frontend-libs/commons'

import { components, popperPlacements, services } from '@/utils'

import badge from '@/components/badge'
import buttonToolbar from '@/components/button/toolbar'
import widget from '@/components/services/notifications/widget'

function renderBadge(h) {
  if (this.hasNewVersion) {
    return h(
      badge,
      {
        class: `${services.notifications}-badge`,
        props: {
          size: 7,
          color: Colors.error,
          exact: {
            top: 8,
            right: 10
          }
        }
      }
    )
  }
}

function renderButton(h, slot, content) {
  return h(
    buttonToolbar,
    {
      props: {
        iconSVG: services.notifications,
        tooltip: this.getTranslate(`misc.buttons.${services.notifications}`)
      },
      slot,
      scopedSlots: {
        dialog: () => {
          return content
        }
      },
      on: {
        click: () => {
          this.show = !this.show
        }
      }
    }
  )
}
function renderContent(h) {
  return h(
    widget,
    {
      props: { show: this.show },
      on: {
        show: event => {
          this.show = event
        }
      }
    }
  )
}

export default function(h) {
  let placement = popperPlacements.bottom
  if (this.viewport.breakpoint.smUp) {
    placement = popperPlacements['bottom-end']
  }

  return h(
    'div',
    { class: `${services.notifications}-button` },
    [
      h(
        components.menu,
        {
          props: {
            closeOnContentClick: false,
            rounded: true,
            offsetDistance: 16,
            placement
          }
        },
        [
          renderButton.call(this, h, 'activator'),
          renderContent.call(this, h)
        ]
      ),
      renderBadge.call(this, h)
    ]
  )
}
